/*************
 * quickView
 * Be sure there is a container element with class js-quick-view-container
 * Internal to the container, be sure there is at lease 1 element with class js-quick-view-button
 * On the element, add a data-quick-view attribute with pipe separated URLs
 *
 * Usage:
 * <div class="js-quick-view-container">
 *      <button class="js-quick-view-button" data-quick-view-handles="url-one|url-two|url-three">Click Here</button>
 * </div>
 */

import tippy from 'tippy.js';
import aa from 'search-insights';
import { DEFAULT_ATTR_TO_RETRIEVE } from '../common/constant';
import { formatCurrency } from '../account/utils';
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import SENTRY from '../custom/sentry.js';

require('custom/utils');

custom.quickView = (() => {
  const breakpoint = 560;

  // Presets
  const $container = $('.js-quick-view-container'); // Wrapper to delegate
  const triggerDataAttr = 'quick-view-handles'; // Data attribute for trigger
  //const pageContentContainerTarget = '#content-for-ajax-load'; // Target page to load content from
  const drawerID = 'quick-view-drawer'; // drawerID and class
  const drawerOpenClass = 'side-panel--open'; // Open class modifier
  const drawerSingleClass = 'quick-view-drawer--single'; // Single Product class modifier
  const drawerMultipleClass = 'quick-view-drawer--multiple'; // Multiple Product class modifier
  const drawerAltProductClass = 'quick-view-drawer--alternative'; // Alternative Products class modifier
  aa('init', {
    appId: algoliaShopify.config.app_id,
    apiKey: algoliaShopify.config.search_api_key,
    useCookie: true,
  });
  const client = algoliasearch(
    algoliaShopify.config.app_id,
    algoliaShopify.config.search_api_key,
  ); // Algolia
  const drawerInventoryActiveClass = 'quick-view-drawer--inventory-active'; // Inventory Active Modifier
  const drawerRetailerActiveClass = 'quick-view-drawer--retailer-active'; // Retailer Active Modifier
  const index = client.initIndex(window.AlgoliaIndices.products); // Algolia Index
  let actions = {
    // PubSub callbacks
    open: [],
    close: [],
  };

  // Subscribe to events
  function on(evt = null, callback = null) {
    if (!evt || !callback || typeof callback !== 'function') return;
    actions[evt] = actions[evt] || [];
    actions[evt].push(callback);
  }

  // Trigger events
  function trigger(evt = null, payload = {}) {
    if (!evt) return;
    actions[evt].forEach((fn) => fn(payload));
  }

  // Helper to parse button data url attributes
  function parseDataQuickViewHandles(dataString = null) {
    return dataString
      ? dataString.toString().replace(/\|$/, '').split('|')
      : false;
  }

  // Clear the contents of the Drawer
  function clearDrawerContents() {
    return $(`.${drawerID}__content`).html('');
  }

  // For transitions inside the panel when open
  function clearDrawerModifierClasses() {
    return $(`#${drawerID}`).removeClass(
      `${drawerSingleClass} ${drawerInventoryActiveClass} ${drawerRetailerActiveClass} ${drawerAltProductClass} ${drawerMultipleClass}`,
    );
  }

  function isMobile() {
    return $(window).width() < 768;
  }

  // Open drawer handler
  function openDrawerHandler(isMultiple = false, shopThisScene = false) {
    clearDrawerModifierClasses(); // Clear all modifier classes

    isMultiple
      ? $(`#${drawerID}`).addClass(drawerMultipleClass)
      : $(`#${drawerID}`).addClass(drawerSingleClass);
    if (shopThisScene) {
      $(`#${drawerID}`).data('category', 'Shop This Scene');
    }

    setTimeout(function () {
      tippy('.js-tippy', {
        animation: 'fade',
        appendTo: document.body,
        arrow: true,
        arrowTransform: 'scaleX(0.75)',
        placement: 'top',
        maxWidth: '238px',
        maxHeight: '81px',
        interactive: true,
      });
      if (isMobile()) {
        tippy('.js-tippy-map', {
          animation: 'fade',
          appendTo: document.body,
          arrow: true,
          arrowTransform: 'scaleX(0.75)',
          placement: 'top',
          offset: '62, 0',
          maxWidth: '238px',
          maxHeight: '81px',
          interactive: true,
        });
      } else {
        tippy('.js-tippy-map', {
          animation: 'fade',
          appendTo: document.body,
          arrow: true,
          arrowTransform: 'scaleX(0.75)',
          placement: 'top',
          maxWidth: '238px',
          maxHeight: '81px',
          interactive: true,
        });
      }
    }, 1000);
    $('.quick-view-inventory-fetch__inner').html(''); // Reset inventory contents
    $(`#${drawerID}`).addClass(drawerOpenClass);

    $('.js-modal-overlay').show();

    $('body').on('click', clickOutsideToClose);
    $(`#${drawerID}`).trigger('focus');
    if (shopThisScene) {
      const targetElement = document.querySelector(`#${drawerID}`);
      disableBodyScroll(targetElement);
    }
  }

  // Close drawer handler
  function closeDrawerHandler() {
    $(`#${drawerID}`).removeClass(`${drawerOpenClass}`);

    setTimeout(() => {
      $(`#${drawerID}`).removeClass(
        `${drawerSingleClass} ${drawerInventoryActiveClass} ${drawerRetailerActiveClass} ${drawerAltProductClass} ${drawerMultipleClass}`,
      );
    }, 500);

    $('.js-modal-overlay').hide();

    $('body').off('click', clickOutsideToClose);
    clearAllBodyScrollLocks(); // Clear body scroll locks
    trigger('close');
  }

  // Click Outside To Close
  // If they click outside side panel, close panel
  function clickOutsideToClose(event = null) {
    if ($(event.target).closest(`#${drawerID}`).length) return;
    if ($(event.target).hasClass('js-quick-view-button')) return;
    closeDrawerHandler();
  }

  // Show Inventory Panel
  function addInventoryActiveClass() {
    removeRetailerActiveClass();
    $(`#${drawerID}`).addClass(drawerInventoryActiveClass);
  }

  // Hide Inventory Panel
  function removeInventoryActiveClass() {
    $(`#${drawerID}`).removeClass(drawerInventoryActiveClass);
  }

  // Show Retailer Panel
  function addRetailerActiveClass() {
    removeInventoryActiveClass();
    $(`#${drawerID}`).addClass(drawerRetailerActiveClass);
  }

  // Hide Retailer Panel
  function removeRetailerActiveClass() {
    $(`#${drawerID}`).removeClass(drawerRetailerActiveClass);
  }

  // Output Product data to Template
  function getProductTemplateSnippet(product = null) {
    if (!product || typeof window.quickPanelProduct === 'undefined') return;
    product = custom.algoliaUtils.collabAuthMapper(product);
    const htmlReturn = window.quickPanelProduct.render(product);
    return htmlReturn;
  }

  // Attach snippet to DOM
  function renderContentToDOM(snippet = null) {
    if (!snippet) return;
    return $(`.${drawerID}__content`).append(snippet);
  }

  // Prep Produc snippet for DOM
  function prepTemplateForDOM() {
    trigger('open');
    custom.loginFormHandler.inputPopupHandler('login-form');
  }

  // Fetch each product's inventory and load it into the main theme liquid
  // quick-view-inventory-fetch container
  function loadInventoryDataToDOM({ handle } = null) {
    if (!handle) return;
    $.ajax({
      type: 'GET',
      url: `/products/${handle}`,
      error: (err) => {
        custom.utils.sendCustomSentryError(`Quick View Inventory failed`, {
          extra: { error: err },
          tags: { module: 'Quick Panel', category: SENTRY.CATEGORIES.PRODUCT },
        });
      },
    }).done((data) => {
      const $inventory = $(data).find('.inventory-panel__table');
      if (
        $('.quick-view-inventory-fetch__inner').find(
          `[data-handle="${handle}"]`,
        ).length
      )
        return;
      $('.quick-view-inventory-fetch__inner').html($inventory);
      const $quickViewItems = $(
        '.quick-view-inventory-fetch__inner .inventory-panel__variant-item',
      );
      const $qvContainer = $(
        '.quick-view-inventory-fetch__inner .inventory-panel__variant',
      );
      if ($inventory.find('.inventory-panel__variant-name').length > 10) {
        $('.quick-view-inventory-fetch').addClass(
          'inventory-panel__content--push-top',
        );
      }
      document
        .querySelectorAll('[data-variant-identifier]')
        .forEach(function (ele) {
          var variantId = parseInt(ele.dataset.variantIdentifier);
          if (variantId) {
            var variantPrice = custom.utils.getVariantPriceById(variantId);
            ele.innerHTML = slate.Currency.formatMoney(
              variantPrice,
              '${{ amount_no_decimals }}',
            );
          }
        });
      setInventoryTableRestockDates();
      $('.quick-view-inventory-fetch__inner').html(
        custom.inventoryPanelSort.inventorySort($quickViewItems, $qvContainer),
      );
      trigger('quick-panel-inventory-loaded');
    });
  }

  function parsePriceByVariantId(data = '', id = '') {
    const variant = JSON.parse(data).variants.filter(
      (variant) => variant.id == id,
    );
    return custom.utils.formatPricing(variant[0].price);
  }

  // Set Inventory Table Restock Dates
  function setInventoryTableRestockDates(hits = null, customPrice = '') {
    $('.js-restock-date-inventory').each((index, lineitem) => {
      const sku = $(lineitem).data('sku');
      const $variantDropDown = $(
        `.js-variant-dropdown [data-variant-sku="${sku}"]`,
      );
      if (
        $variantDropDown &&
        $variantDropDown.length &&
        $variantDropDown.data('restock-date')
      ) {
        const restockDate = $variantDropDown.data('restock-date');
        $(lineitem).text(restockDate);
      }
    });
  }

  // Parse Product Data from Algolia
  function parseAlgoliaProductData(hits = null, customPrice = '') {
    if (!hits) return;
    let isPillow =
      hits[0]._highlightResult.product_type.value == 'PILLOWS' ? true : false;
    if (isPillow) {
      hits = hits.sort((a, b) => {
        let aSize = a.options.size
          .replace('"', '')
          .replace('"', '')
          .split(' x ');
        let bSize = b.options.size
          .replace('"', '')
          .replace('"', '')
          .split(' x ');
        let firstPair = aSize[0] + aSize[1];
        let secondPair = bSize[0] + bSize[1];
        return firstPair - secondPair;
      });
    }
    let product = custom.algoliaUtils.resultObjectReducer(hits[0]);
    let variants_count = custom.algoliaUtils.variantsCount(product);
    const title = productTitleFormatter(product.title);
    const productTitle = productTitleWrapFormatter(title);

    return {
      ...product,
      ...variants_count,
      collection_handle:
        product.product_type == 'RUG PADS'
          ? 'rug-pads'
          : product['collection_handle'],
      title: title,
      productTitle: productTitle,
      collection:
        product.named_tags && product.named_tags.Collection
          ? product.named_tags.Collection
          : '',
      collaboration:
        product.named_tags && product.named_tags.Collaboration
          ? product.named_tags.Collaboration
          : '',
      collaboration_handle: product.collaboration_handle
        ? product.collaboration_handle
        : '',
      price: customPrice || product.price,
      restockDate:
        product.meta && product.meta.loloi && product.meta.loloi.eta_date
          ? product.meta.loloi.eta_date
          : '',
      leadTime:
        product.meta && product.meta.loloi && product.meta.loloi.lead_time
          ? product.meta.loloi.lead_time
          : '',
      variants: [],
    };
  }

  function productTitleFormatter(str = 'No title') {
    const titleCase = custom.utils.titleCase(str);

    var [firstWord, secondWord, ...rest] = titleCase.split(' ');

    if (firstWord && firstWord.indexOf('-') != -1) {
      var [beforeEn, afterEn] = firstWord.split('-');
      firstWord = `${beforeEn.toUpperCase()}-${afterEn}`;
    }

    if (secondWord && secondWord.length == 2) {
      secondWord = secondWord.toUpperCase();
    }

    return `${firstWord} ${secondWord ? secondWord : ''} ${
      rest ? rest.join(' ') : ''
    }`;
  }

  function productTitleWrapFormatter(str = 'No title') {
    var words = str.split(' ');
    var lastWord = '<span class="white-space-nowrap">' + words.slice(-1);
    words[words.length - 1] = lastWord;
    return words.join(' ');
  }

  // Parse Variant Data from Algolia
  function parseAlgoliaVariantData(
    {
      meta,
      sku,
      price,
      objectID,
      variant_title,
      inventory_quantity,
      restockDate,
      leadTime,
      rugSize,
    } = null,
  ) {
    let map_price = '';
    if (
      meta &&
      meta.loloi &&
      meta.loloi.map_category &&
      meta.loloi.map_category == 'MAP'
    ) {
      if (window.LoloiConfig.price_region == 'USA') {
        map_price =
          meta && meta.loloi && meta.loloi.usa_map && meta.loloi.usa_map > 0
            ? formatCurrency(meta.loloi.usa_map) + ' MAP'
            : '';
      } else if (window.LoloiConfig.price_region == 'Canadian/International') {
        map_price =
          meta &&
          meta.loloi &&
          meta.loloi.canada_map &&
          meta.loloi.canada_map > 0
            ? formatCurrency(meta.loloi.canada_map) + ' MAP'
            : '';
      }
    } else if (
      meta &&
      meta.loloi &&
      meta.loloi.map_category &&
      meta.loloi.map_category.toUpperCase() == 'NO MAP'
    ) {
      map_price = 'No MAP';
    }
    return {
      sku,
      price,
      objectID,
      variant_title,
      inventory_quantity,
      restockDate:
        meta && meta.loloi && meta.loloi.eta_date
          ? meta.loloi.eta_date
          : restockDate,
      leadTime:
        meta && meta.loloi && meta.loloi.lead_time
          ? meta.loloi.lead_time
          : leadTime,
      mapPrice: map_price,
      soldOut: inventory_quantity <= 0 ? true : false,
      isSelected: variant_title == rugSize ? true : false,
    };
  }

  /**
   * removeDiscontinedVariants
   *
   * @param {object} hits - Product Variant Objects
   * If that product is Discontinued and OOS,
   * just remove from Product Variants
   */
  function removeDiscontinuedVariants(hits = {}) {
    return hits.filter((hit) => {
      return !(
        custom.algoliaUtils.hitIsDiscontinued(hit) &&
        hit.inventory_quantity <= 0
      );
    });
  }

  // Helper to parse and group hits by Algolia
  function parseAlgoliaHits(
    err,
    { hits },
    isMultiple = false,
    handles,
    rugSize,
    rugId,
    itemIndex,
    itemListName,
    itemListId,
    shopThisScene = false,
    isRugPadDriver = false,
  ) {
    if (err) throw err;
    hits = removeDiscontinuedVariants(hits);
    let product;
    let prodcutsList = [];
    //loop through each handle
    let productIndex = 1;
    handles.forEach((handle, i) => {
      let variants = [];
      //find the hits (variants) that match
      const handleHits = hits.filter((hit) => hit.handle == handle);
      handleHits.forEach((hit, j) => {
        hit.rugSize = rugSize;
        variants.push(hit);
      });
      //add to quick panel
      if (variants.length > 0) {
        product = parseAlgoliaProductData(variants);
        product.rugId = rugId ? rugId : null;
        variants.forEach((v) => {
          product.variants.push(parseAlgoliaVariantData(v));
        });
        if (isMultiple || shopThisScene) {
          product.itemIndex = productIndex;
          productIndex += 1;
          product.itemListName = itemListName ? itemListName : '';
          product.itemListId = itemListId ? itemListId : '';
          product.gtmTrackVariantSelect = true;
          if (isRugPadDriver) {
            product.isRugPadDriver = true;
          }
        } else {
          product.itemIndex = itemIndex ? itemIndex : 1;
        }

        renderContentToDOM(getProductTemplateSnippet(product));
        variants.length = 0;
        prodcutsList.push(product);
      }

      if (!isMultiple) loadInventoryDataToDOM(product);
      prepTemplateForDOM();
    });
    if (isMultiple || shopThisScene) {
      if (!prodcutsList.length) return;
      const data = {
        ecommerce: {
          currency: 'USD',
          item_list_name: itemListName,
          item_list_id: itemListId,
          items: prodcutsList.map((product, index) => {
            let productData = {
              item_id: product.id.toString(),
              item_variant: product.objectID ? product.objectID : '',
              item_name: product.title ? product.title : product.name,
              index: product.itemIndex ? product.itemIndex : index + 1,
            };
            if (product.named_tags && product.named_tags.Color) {
              productData.item_color = product.named_tags.Color.toString();
            }
            if (product.named_tags && product.named_tags.Collaboration) {
              productData.item_collaboration = product.named_tags.Collaboration;
            }
            if (product.named_tags && product.named_tags.Collection) {
              productData.item_brand = product.named_tags.Collection;
            }
            return productData;
          }),
        },
      };
      custom.gtmDatalayer.gtmPushNew(data, 'view_item_list');
    }
  }

  // Helper to fetch data from source
  function getProductData(
    handles = null,
    isMultiple = false,
    rugSize,
    rugId,
    itemIndex,
    itemListName,
    itemListId,
    shopThisScene = false,
    isRugPadDriver = false,
  ) {
    let filters = '';
    let query = '';
    if (!handles) return;
    const attributes = 'handle';
    handles.forEach((id, i) => {
      filters += i == 0 ? `handle:"${id}"` : ` OR handle:"${id}"`;
    });

    // https://www.algolia.com/doc/api-reference/search-api-parameters/
    index
      .search(query, {
        filters: filters,
        typoTolerance: false,
        hitsPerPage: 100,
        restrictSearchableAttributes: attributes,
        attributesToRetrieve: [...DEFAULT_ATTR_TO_RETRIEVE, 'body_html_safe'],
      })
      .then((res) => {
        if (!res.hits || res.hits.length === 0) {
          console.warn('No hits found for the provided handles:', handles);
          return;
        }
        // Send click analytics to Algolia
        aa('getUserToken', {}, (err, userToken) => {
          if (err) {
            return;
          }
          const objectIDs = res.hits.map((hit) => hit.objectID);
          aa('clickedObjectIDs', {
            userToken: userToken,
            index: window.AlgoliaIndices.products,
            eventName: 'Product Clicked',
            objectIDs: objectIDs,
          });
        });
        parseAlgoliaHits(
          null,
          res,
          isMultiple,
          handles,
          rugSize,
          rugId,
          itemIndex,
          itemListName,
          itemListId,
          shopThisScene,
          isRugPadDriver,
        );
      })
      .catch((error) => {
        console.error('Algolia Search Error:', error);
        // Handle the error state for the DOM here
        // closeDrawerHandler()
      });
  }

  // Load content to Drawer
  function initiateDrawerSequence(event = {}) {
    event.preventDefault();
    event.stopPropagation();
    const $button = $(event.currentTarget);
    let itemIndex = $button.data('item-index') ? $button.data('item-index') : 1;
    if (itemIndex) itemIndex = parseInt(itemIndex);
    let itemListName = $button.data('item-list-name');
    let itemListId = $button.data('item-list-id');

    const productHandlesArray = parseDataQuickViewHandles(
      $button.data(triggerDataAttr),
    );
    const isMultiple = productHandlesArray.length > 1;
    const shopThisScene = $button.text().includes('Shop This Scene');
    const isRugPadDriver = $button.text().includes('Add Rug Pad');
    if (shopThisScene) {
      if (!itemListName) {
        itemListName = 'Shop This Scene';
      }
      if (!itemListId) {
        let pageTitle = document.title;
        if (pageTitle.includes('|')) {
          pageTitle = pageTitle.split('|')[0].trim();
        }
        const butonIndex =
          document.querySelectorAll('.js-quick-view-button').length > 0
            ? Array.from(
                document.querySelectorAll('.js-quick-view-button'),
              ).indexOf($button[0]) + 1
            : 0;
        if (butonIndex) {
          pageTitle = `${pageTitle} -> ${butonIndex}`;
        }
        itemListId = pageTitle;
      }
    }
    const rugPads = $button.data('rugpads');
    const rugSize = $button.data('size');
    const rugId = $button.data('rugid');

    if (!productHandlesArray || !productHandlesArray.length) return;

    clearDrawerContents();
    openDrawerHandler(isMultiple, shopThisScene);
    if (!isMultiple && !shopThisScene) {
      custom.gtmSelectItem.sendGTMSelectItemEvent($button, true);
    }
    // if this is rug pads we need to append content to the top
    if (rugPads) {
      renderContentToDOM(
        `<div class="quick-view-drawer__detail text-center"><h1 class="title-medium spacer--2--mb">Rug Pads</h1><p class="body-medium mb-6">It’s true: Every rug needs a rug pad. Prevent slipping, add cushion, and improve durability with our three options. Rug pads are recommended for rugs placed indoors or in covered outdoor areas.</p><img class="mx-auto" src="https://cdn.shopify.com/s/files/1/2718/0696/files/rug_pad_comparison_2585de79-18ae-48eb-a74f-254171efe743.jpg?v=1734653451" alt=""></div>`,
      );
    }
    getProductData(
      productHandlesArray,
      isMultiple,
      rugSize,
      rugId,
      itemIndex,
      itemListName,
      itemListId,
      shopThisScene,
      isRugPadDriver,
    );
  }

  function hideMultiplesRetailer(e) {
    if (!e) return;
    let $targetDiv = $(e.target).closest('.quick-view-product-fetch');
    $('.quick-view-product-fetch').not($targetDiv).addClass('hidden');
    $('#quick-view-drawer').scrollTop(0);
  }

  // Delegate event listeners to Container
  function addEventListeners() {
    $container.on('click', '.js-quick-view-button', initiateDrawerSequence);
    $('body').on('click', `.${drawerID}__close`, closeDrawerHandler);

    // Inventory Panel Switcher
    $('body').on(
      'click',
      `.js-quick-view-show-inventory`,
      addInventoryActiveClass,
    );
    $('body').on('click', `.js-quick-view-hide-inventory`, function () {
      removeRetailerActiveClass();
      removeInventoryActiveClass();
    });

    // Retailer Panel Reveal
    $('body').on('click', `.js-quick-view-show-retailer`, function (e) {
      e.preventDefault();
      removeInventoryActiveClass();
      hideMultiplesRetailer(e);
      addRetailerActiveClass();
    });
  }

  // Add drawer to the DOM
  function addDrawerToDOM() {
    if (!window.quickPanel) return;
    return !$(`#${drawerID}`).length
      ? $('body').append(window.quickPanel.render())
      : false;
  }

  // Init prep the DOM
  if ($container.length) addDrawerToDOM();
  addEventListeners();

  return {
    on,
    initiateDrawerSequence,
    closeDrawerHandler,
    addRetailerActiveClass,
  };
})();



// WEBPACK FOOTER //
// ./src/scripts/src/custom/quick-panel.js